// Single source of truth for the Aquila Air & Heating guarantees.
// Used on the public website (/guarantees, homepage) and in the Command Center dashboard.
export const GUARANTEES = [
  {
    icon: "ShieldCheck",
    title: "100% Satisfaction Guarantee",
    short: "We make it right — period.",
    desc: "If you are not completely satisfied with our work, we will do whatever it takes to make it right.",
  },
  {
    icon: "Thermometer",
    title: "Temperature Selection Guarantee",
    short: "Your system holds the temperature you set.",
    desc: "When properly maintained and operated to manufacturer requirements, your system will deliver within one degree of your digital thermostat setting — heating or cooling. If it does not, we will make any necessary repairs to reach it.",
  },
  {
    icon: "Clock",
    title: "On-Time Installation Guarantee",
    short: "Installed on the date we promise.",
    desc: "We guarantee your installation will be completed on the date we promise. If we miss our commitment due to our own error, we will make it right.",
  },
  {
    icon: "Sparkles",
    title: "Comfort Guarantee",
    short: "A comfortable home, guaranteed.",
    desc: "We guarantee your new system will keep your home comfortable. If it does not perform as promised, we will repair or replace it.",
  },
  {
    icon: "House",
    title: "Property Protection Guarantee",
    short: "We treat your home like our own.",
    desc: "Floor savers, drop cloths, and a complete clean-up when we're done. Any damage we cause during the job, we repair.",
  },
  {
    icon: "BadgeCheck",
    title: "No-Lemon Guarantee",
    short: "A brand-new unit, not just a part.",
    desc: "If the compressor or heat exchanger in your new system fails within the covered warranty period, we will install a brand-new unit — not just a replacement part.",
  },
  {
    icon: "DollarSign",
    title: "Fair Price Guarantee",
    short: "The price we quote is the price you pay.",
    desc: "We provide honest, upfront pricing with no hidden fees and no overtime charges. The price we quote is the price you pay.",
  },
  {
    icon: "HeartHandshake",
    title: "Respect Guarantee",
    short: "Courteous, background-checked pros.",
    desc: "Our technicians are background-checked, drug-tested, courteous professionals who respect you, your family, and your home.",
  },
];
